(ns app.survey.routes
  (:require
   [ajax.core :as ajax]
   [bidi.bidi :as bidi]
   [common.localization :as loc]
   [frontend.logging :as logging]
   [pushy.core :as pushy]
   [re-frame.core :as rf]
   [re-frame.core :as re-frame]
   [ui.components.alert-list.event :as alert-list-event]))

(def routes
  ["/"
   {"survey"
    {""               :form
     "/no-access"     :no-access
     "/select-survey" :select-survey
     "/loading"       :loading
     "/login"         :login}}])

(defn parse
  [url]
  (let [r (bidi/match-route routes url)]
    r))

(defn url-for
  [& args]
  (apply bidi/path-for (into [routes] args)))

(rf/reg-sub
 ::route
 (fn [db]
   (::route db)))

(rf/reg-event-fx
 ::on-logout-ok
 (fn [{db :db} [_ {:keys [body] :as resp}]]
   (set! (.-pathname js/window.location) "/")))

(rf/reg-event-fx
 ::on-logout-failed
 (fn [{db :db} [_ resp]]
   (logging/unimplemented "Survey app config failed : " resp)
   {:fx [[:dispatch
          [::alert-list-event/add-alert
           {:list-id         :login-notifications
            :hide-in-ms      3000
            :variant         :danger
            :message-content [:div
                              (loc/tr :failed-to-logout)]}]]]}))

(rf/reg-event-fx
 ::set-route
 (fn [{db :db} [_ route]]
   (let [old-route (get db ::route)
         route (if (and (= (:handler route) :loading)
                        (= (:handler old-route) :form))
                 (do
                   (js/console.log "No back button from FORM")
                   old-route)
                 route)]
     {:db (assoc db ::route route)})))

(defn dispatch
  [route]
  (rf/dispatch [::set-route route]))

(defonce history
  (pushy/pushy dispatch parse))

(defn start!
  []
  (pushy/start! history))

(re-frame/reg-event-fx
 ::navigate
 (fn [{db :db} [_ handler]]
   (pushy/set-token! history (apply url-for handler))))
